import { COLOR, float, line } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'MAMA',
  version: 1,
  label: 'MESA Adaptive Moving Average',
  pane: 'main',
  category: 'cycles',
  series: 'price',
  order: 20,
  inputs: [float('fastlimit', 0.5, 'Fast limit', 0.01, 0.99, 0.01), float('slowlimit', 0.05, 'Slow limit', 0.01, 0.99, 0.01)],
  outputs: [line('mama', 'MAMA', COLOR.blue), line('fama', 'FAMA', COLOR.orange)],
  talib: {
    functions: ['MAMA'],
    expr: 'MAMA(close, fastlimit={fastlimit}, slowlimit={slowlimit})',
    outputs: { mama: 'mama', fama: 'fama' },
  },
  listed: true,
  tailSafe: true,
  // TA_MAMA_Lookback: a fixed 32 (12 Tradestation + 6 detrender + 6 Q1 + 3 jI + 3 jQ + 1 Re/Im + 1 delta phase), inputs do not matter.
  lookback: () => 32,
}
export default def
